// extracted by mini-css-extract-plugin
module.exports = {"block":"AddPhotoInput_block__11n0U","container":"AddPhotoInput_container__wKJA4","photo":"AddPhotoInput_photo__3SLTv","text":"AddPhotoInput_text__2mubI"};